import { useMediaQuery, useTheme } from '@mui/material';

type TBreakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
type TMediaQueryHook = () => boolean;

function createMediaQueryHook(breakpoint: TBreakpoint): TMediaQueryHook {
  return () => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.only(breakpoint));
  };
}

// export const useIsMobile = createMediaQueryHook('xs');
export const useIsDesktop = createMediaQueryHook('md');
